import { render, staticRenderFns } from "./wuliu.vue?vue&type=template&id=e0474d6c&scoped=true&"
import script from "./wuliu.vue?vue&type=script&lang=js&"
export * from "./wuliu.vue?vue&type=script&lang=js&"
import style0 from "./wuliu.vue?vue&type=style&index=0&id=e0474d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0474d6c",
  null
  
)

export default component.exports